import React, { useState, useEffect } from "react"
import CustomReactTable from "components/Templates/CustomReactTable"
import { useSearchFilter } from "hooks/searchFilterHooks"
import {
  useSellableItemList,
  useSellableListSubItems,
} from "graphql/stock-summary/stock-summary.hooks"
import BackButton from "components/Templates/BackButton"
import { Description } from "components/Templates/ModuleHeader"
import { useDistributionCenterDetails } from "graphql/distribution-center/distribution-center.hooks"
import { useParams } from "react-router-dom"
import DateSelector from "components/Templates/DateSelector"
import TableActionsButton from "./TableActionsButton"
import TablePagination from "components/Molecules/TablePagination"

const SellableItemList = () => {
  const [{ date, page }, setFilter] = useSearchFilter()
  const { id } = useParams()
  const { data, loading } = useSellableItemList()

  const [dcDetails, setDetails] = useState(null)
  const [getDetails] = useDistributionCenterDetails(
    ({ distributionCentreLocationDetail: dcl }) => {
      const dc = dcl?.properties

      setDetails({
        id: dcl?.id,
        name: dc?.name,
        dcoName: dc?.primaryPoc?.fullName,
        dcoNumber: dc?.primaryPoc?.number,
      })
    }
  )

  useEffect(() => {
    if (parseInt(id)) {
      getDetails({ variables: { id } })
    }
  }, [id, getDetails])

  const COLUMNS = [
    {
      Header: "Sellable item",
      accessor: "sellableItem",
      minWidth: 200,
      Cell({ value }) {
        return <div>{value?.name}</div>
      },
    },
    {
      Header: "Active batch",
      accessor: "activeStockCount",
      Cell({ value }) {
        return <div>{value}</div>
      },
    },
    {
      Header: "Opening",
      accessor: "opening",
      Cell({ value }) {
        return <div>{value}</div>
      },
    },
    {
      Header: "Inwarded",
      accessor: "inwarded",
      Cell({ value }) {
        return <div>{value}</div>
      },
    },
    {
      Header: "In transit",
      accessor: "inTransit",
      Cell({ value }) {
        return <div>{value}</div>
      },
    },
    {
      Header: "Delivered",
      accessor: "delivered",
      Cell({ value }) {
        return <div>{value}</div>
      },
    },
    {
      Header: "Return",
      accessor: "returned",
      Cell({ value }) {
        return <div>{value}</div>
      },
    },
    {
      Header: "Direct sale",
      accessor: "directSale",
      Cell({ value }) {
        return <div>{value}</div>
      },
    },
    {
      Header: "Disposal",
      accessor: "disposal",
      Cell({ value }) {
        return <div>{value}</div>
      },
    },
    {
      Header: "Closing",
      accessor: "closing",
      Cell({ value }) {
        return <div>{value}</div>
      },
    },
  ]

  const SubRowAsync = () => {
    const { data, loading } = useSellableListSubItems()
    if (loading) return <div>Loading...</div>
    return (
      <table className="table align-middle">
        <tbody>
          {data?.batchStockWiseVisibility?.map(item => (
            <tr className="table-warning fs-10">
              <td className="text-center" style={{ width: "35px" }}>
                &nbsp;
              </td>
              <td className="text-center" style={{ width: "238px" }}>
                &nbsp;
              </td>
              <td
                className="text-center fs-10"
                style={{ width: "120px", fontSize: "14px" }}
              >
                {item?.batchStock?.id}
              </td>
              <td
                className="text-center"
                style={{ width: "120px", fontSize: "14px" }}
              >
                {item?.opening}
              </td>
              <td
                className="text-center"
                style={{ width: "120px", fontSize: "14px" }}
              >
                {item?.inwarded}
              </td>
              <td
                className="text-center"
                style={{ width: "120px", fontSize: "14px" }}
              >
                {item?.inTransit}
              </td>
              <td
                className="text-center"
                style={{ width: "120px", fontSize: "14px" }}
              >
                {item?.delivered}
              </td>
              <td
                className="text-center"
                style={{ width: "120px", fontSize: "14px" }}
              >
                {item?.returned}
              </td>
              <td
                className="text-center"
                style={{ width: "120px", fontSize: "14px" }}
              >
                {item?.directSale}
              </td>
              <td
                className="text-center"
                style={{ width: "120px", fontSize: "14px" }}
              >
                {item?.disposal}
              </td>
              <td
                className="text-center"
                style={{ width: "120px", fontSize: "14px" }}
              >
                {item?.closing}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    )
  }

  return (
    <div>
      <section className={"vt-module-header p-3"}>
        <div className="vt-module-description">
          <div className="flex items-center">
            <BackButton className="mr-2" />
            <Description icon="th-list" title={dcDetails?.name} />
          </div>
        </div>
        <div className="vt-module-accessories flex items-center">
          <TablePagination
            className="mr-3"
            page={page}
            onPageChange={page => {
              setFilter(prev => ({
                ...prev,
                page,
              }))
            }}
          />
          <TableActionsButton className="mr-3" />
          <DateSelector
            value={date}
            onChange={(_, date) => {
              setFilter(prev => ({
                ...prev,
                date,
              }))
            }}
          />
        </div>
      </section>

      <CustomReactTable
        loading={loading}
        loadingText="Fetching data"
        data={data?.sellableItemWiseStockVisibility ?? []}
        columns={COLUMNS}
        SubComponent={row => <SubRowAsync row={row.original} />}
      />
    </div>
  )
}

export default SellableItemList
